import { configureStore } from "@reduxjs/toolkit";

import appReducer, { initialState, localeToCurrencyMap } from "./app/appSlice";

export const createStore = ({ locale = "en-US" }) =>
  configureStore({
    reducer: {
      app: appReducer,
    },
    preloadedState: {
      app: {
        ...initialState,
        locale,
        currency: localeToCurrencyMap[locale] || "USD",
      },
    },
  });
